// https://vuex.vuejs.org/en/mutations.html

import {getDefaultState} from './index'

const mutations = {
    /*INITIALIZE_STORAGE: (state) => {
        localStorage.setItem("store", JSON.stringify(state));
    },*/
    SET_TOKEN: (state, token) => {
        state.api.token = token;
    },
    SET_PROFILE: (state, profile) => {
        state.profile = profile;
    },
    SET_LOCALE: (state, locale) => {
        state.profile.language = locale;
    },
    LOGOUT: (state) => {
        let defaultState = getDefaultState();
        Object.assign(state, defaultState);
        localStorage.setItem("store", JSON.stringify(defaultState));
    },
    SET_STATE_FROM_STORAGE: (state) => {
        Object.assign(state, JSON.parse(localStorage.getItem("store")));
    }

};

export default mutations;
